export const getTitle = (step: 1 | 2 | 3 | 4, isMobile: boolean) => {
    if (!isMobile && (step === 2 || step === 3)) {
        return 'security_verification'
    }

    switch (step) {
        case 4:
            return 'your_address_added'
        default:
            return 'add_withdrawal_address'
    }
}

export const getSubTitle = (step: 1 | 2 | 3 | 4, isMobile: boolean) => {
    if (!isMobile && (step === 2 || step === 3)) {
        return 'verify_identity'
    }

    switch (step) {
        case 4:
            return ''
        default:
            return 'to_secure_add_withdrawal_address'
    }
}